<template>
  <div class="bg-white flex justify-center shadow">
    <inertia-link :href="route('jobs.edit', {job: job.id})" :class="isUrl(route('jobs.edit', {job: job.id})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
      {{ __("Details") }}
    </inertia-link>

    <inertia-link v-if="job.canChat" :href="route('jobConversation.show', {jobUuid: job.uuid})" :class="isUrl(route('jobConversation.show', {jobUuid: job.uuid})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
      {{ __("Conversation") }}
    </inertia-link>

    <inertia-link :href="route('jobActivityLogs.index', {job: job.id})" :class="isUrl(route('jobActivityLogs.index', {job: job.id})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
      {{ __("History") }}
    </inertia-link>

    <inertia-link v-if="job.reportCardEnabled" :href="route('reportCards.show', {job: job.id})" :class="isUrl(route('reportCards.show', {job: job.id})) ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600 flex items-center gap-1">
      {{ __("Report card") }}
      <svg v-if="job.reportCardFinalized" :title="__('Report card finalized')" class="w-4 h-4 text-green-500 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm-1.04 14.84-4-4 1.4-1.42 2.6 2.59 5.6-5.59 1.42 1.41-7 7z"/>
      </svg>
      <svg v-else-if="job.reportCardComplete" :title="__('Report card complete, PDF not generated')" class="w-4 h-4 text-yellow-500 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.13 2.5a1 1 0 0 1 1.74 0l8.65 14.99a1 1 0 0 1-.87 1.51H1.35a1 1 0 0 1-.87-1.51L9.13 2.5zM9 8v4h2V8H9zm0 5v2h2v-2H9z"/>
      </svg>
      <svg v-else :title="__('Report card incomplete')" class="w-4 h-4 text-red-500 fill-current" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.13 2.5a1 1 0 0 1 1.74 0l8.65 14.99a1 1 0 0 1-.87 1.51H1.35a1 1 0 0 1-.87-1.51L9.13 2.5zM9 8v4h2V8H9zm0 5v2h2v-2H9z"/>
      </svg>
    </inertia-link>

    <inertia-link v-if="job.infoComplete" :href="route('actionRequests.index', {job: job.id})" :class="isRoute('actionRequests.index') || isRoute('actionRequests.create') || isRoute('actionRequests.show') ? 'text-coral-400' : 'text-white hover:text-coral-400'" class="mx-4 py-3 text-gray-600">
      {{ __("Notifications") }}
    </inertia-link>
  </div>
</template>

<script>

  export default {
    props: {
      job: Object
    },
  }
</script>
